module.exports = __webpack_public_path__ + "img/background-panel-hello--dark.0961c346.svg";